import { localizedString } from '@locale/locale';
import { message } from 'antd';

export const copyToClipboard = (str: string, successText?: string) => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  const styleText = 'position: absolute; left: -9999px; opacity: 0;';
  el.style.cssText = styleText;
  document.body.appendChild(el);

  const selected =
    (document.getSelection() as any).rangeCount > 0
      ? (document.getSelection() as any).getRangeAt(0)
      : false;

  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);

  if (selected) {
    (document.getSelection() as any).removeAllRanges();
    (document.getSelection() as any).addRange(selected);

    message.success(successText || localizedString('common_copy_success'));
  }
};
